import { render, staticRenderFns } from "./CaseAdd.vue?vue&type=template&id=39741a74&scoped=true&lang=pug&"
import script from "./CaseAdd.vue?vue&type=script&lang=js&"
export * from "./CaseAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39741a74",
  null
  
)

export default component.exports